module.exports = __webpack_public_path__ + "static/img/twjd-sdo16.f52eb30.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo16.png
// module id = 858
// module chunks = 0